// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"576":"cd662b5f","749":"211d79a4"}[chunkId] + ".chunk.js";
};